import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as Goal } from "../../assets/goal-icon.svg";

export const GoalIcon = (props: SvgIconProps) => {
  return <SvgIcon component={Goal} {...props} />;
};
